/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { toLocale, toCurrency, toPercent } from '../../helpers/numberHelper';

import CardItem from './cardItem';
import ChangeCard from './changeCard';

import './card.style.css';
import { isNil } from 'lodash';

const Card = ({
    date,
    dateNotFormatted,
    currency,
    rooms = 0,
    ungRooms = 0,
    revenue = 0,
    ungRevenue = 0,
    adr = 0,
    revPar = 0,
    occupancy = 0,
    forecast,
    budget,
    lySpitRevenue,
    change,
    cardClicked,
    showUnguaranteed = true,
    showChange = true,
    showBudget = true,
    showForecast,
    isLySpit,
}) => {
    const onClick = () => {
        cardClicked(dateNotFormatted);
    };

    return (
        <>
            <div
                className="Card"
                title={
                    isLySpit && lySpitRevenue > revenue
                        ? `You are behind on LY-SPIT - Click to view ${date}`
                        : `Click to view ${date}`
                }
                onClick={onClick}
            >
                <div className={isLySpit && lySpitRevenue > revenue ? 'CardHeaderHighlighted' : 'CardHeader'}>
                    <div>
                        <span>{date}</span>
                    </div>
                </div>
                <div className="CardRow">
                    <CardItem label="Rooms" value={toLocale(rooms)} />
                    {showUnguaranteed && <CardItem label="Ung." value={toLocale(ungRooms)} style="secondary" />}
                    <CardItem label="Revenue" value={toCurrency(revenue / 100, currency)} />
                    {showUnguaranteed && (
                        <CardItem label="Ung." value={toCurrency(ungRevenue / 100, currency)} style="secondary" />
                    )}
                </div>
                <div className="CardRowSeparator" />
                <div className="CardRow">
                    <CardItem label="ADR" value={toCurrency(adr / 100, currency, 2)} />
                    <CardItem label="RevPar" value={toCurrency(revPar / 100, currency, 2)} />
                    <CardItem label="Occupancy" value={toPercent(occupancy)} />
                </div>
                <div className="CardRowSeparator" />
                <div className="CardRow">
                    <CardItem
                        label="Forecast"
                        value={isNil(forecast) || !showForecast ? 'N/A' : toCurrency(forecast / 100, currency)}
                    />
                    {showBudget && (
                        <CardItem label="Budget" value={budget === null ? 'N/A' : toCurrency(budget / 100, currency)} />
                    )}
                    {showChange && <ChangeCard value={change} />}
                    <CardItem
                        label={isLySpit ? 'LY-SPIT' : 'LY-Final'}
                        value={lySpitRevenue === null ? 'N/A' : toCurrency(lySpitRevenue / 100, currency)}
                    />
                </div>
            </div>
        </>
    );
};

export default Card;
